import { gql } from "apollo-boost";
import { relatedArticleImage } from "querypieces";

export default gql`
    query($relatedTo:[Int], $limit:Int) {
        entries(section: "blog", relatedTo: $relatedTo, limit: $limit) {
            id
            ... on blog_blog_Entry {
              id
              altText
              articleType
              ${relatedArticleImage}
              blogPostHeaderMatrix {
                ... on blogPostHeaderMatrix_blogPostHeading_BlockType {
                  id
                  header
                  publisher
                  date
                  authors
                }
              }
              uri
            }
            ... on blog_externalPost_Entry {
              id
              altText
              articleType
              externalUrl {
                  url
              }
              blogPostHeaderMatrix {
                ... on blogPostHeaderMatrix_blogPostHeading_BlockType {
                  id
                  date
                  authors
                  header
                  publisher
                }
              }
              ${relatedArticleImage}
            }         
        }
    }
`;



